// firebase.ts - using Firebase v9 modular SDK
import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getFunctions } from "firebase/functions";
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider, AppCheck } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyC27mbrrWfmSuDngewX-4Z36Wf3xpnLyes",
  authDomain: "breck-vipers.firebaseapp.com",
  projectId: "breck-vipers",
  storageBucket: "breck-vipers.firebasestorage.app",
  messagingSenderId: "627994550613",
  appId: "1:627994550613:web:ca78a05cdadae234440fdc",
  measurementId: "G-FQ4YE77KZN"
};

const app = initializeApp(firebaseConfig);

// App Check (Employee-Ops P1) — proves requests originate from our app so the
// new App-Check-enforced callables (createInvitation/acceptInvitation/etc.)
// accept them. No-ops when REACT_APP_RECAPTCHA_SITE_KEY is unset so local dev
// and the public storefront keep working without a key.
let appCheck: AppCheck | undefined;
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (recaptchaSiteKey) {
  // Optional debug token for local/CI (Firebase console -> App Check -> debug).
  const debugToken = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  if (debugToken) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  }
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    console.warn('App Check initialization failed; continuing without it:', error);
  }
}

const db = getFirestore(app);
const functions = getFunctions(app, 'us-central1');  // Explicitly set region
const auth = getAuth(app);
const storage = getStorage(app);

// Handle Firestore connection issues
const handleFirestoreConnectionError = async () => {
  try {
    console.log('Attempting to reconnect Firestore...');
    await disableNetwork(db);
    await enableNetwork(db);
    console.log('Firestore connection reset');
  } catch (error) {
    console.error('Failed to reset Firestore connection:', error);
  }
};

export { firebaseConfig, app, appCheck, db, functions, auth, storage, handleFirestoreConnectionError };
